var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"left-button-to":{ name: 'settings' },"left-button-icon-name":"back","title":_vm.$t('network.settings.title'),"header-fill":"light","fill":"neutral"}},[_c('AeCard',{attrs:{"fill":"maximum"}},[_c('NetworkSwitcher',{attrs:{"network-add-button-to":{ name: 'settings-network-new' }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }